import { Button } from '@nazka/nazka.mapframe.components';
import theme from '@css/theme.style.json';

function StyledButton(props) {
  return (
    <Button 
      {...props}
      css={{
        borderRadius: theme.layout['border-radius'].big,
        padding: `calc(${theme.layout.spacing} * 2) calc(${theme.layout.spacing} * 6)`,
        transition: 'background 0.2s, border 0.2s',
        fontSize: theme.typography.font.size.medium,
        ...(props?.css ? props.css : {}),
      }}
      color={props.color ? props.color : theme.color.yellow.primary}
      hoverColor={props.hoverColor ? props.hoverColor : theme.color.blue.primary}
    />
  );
}

export default StyledButton;
